<template>
    <div>
        <b-card>
            <b-row>
                <b-col cols="6">
                    <label for="email">Warehouse Name</label>
                    <b-form-input id="Type" type="text" placeholder="Warehouse Name" v-model="warehouseId.name"
                        disabled />

                </b-col>
                <b-col cols="6">
                    <label for="email">Address</label>
                    <b-form-input id="address" type="text" placeholder="Address" v-model="warehouseId.address"
                        disabled />
                </b-col>
            </b-row>
        </b-card>
        <b-row class="mt-2">
            <b-col md="2" sm="4" class="my-1">
                <b-form-group class="mb-0">
                    <label class="d-inline-block text-sm-left mr-50">Per page</label>
                    <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions" class="w-50" />
                </b-form-group>
            </b-col>
            <b-col md="4" sm="8" class="my-1"> </b-col>
            <b-col md="6" class="my-1 ">
                <b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm"
                    label-for="filterInput" class="mb-0">
                    <b-input-group size="sm">
                        <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Type to Search" />
                    </b-input-group>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="itemBalance"
                    :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
                    :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                    <template #cell(productName)="data">
                        <b-link :to="{path: `/product/view/${data.item.productId}`}">{{data.item.productName}}</b-link>
                    </template>
                </b-table>
                <div class="d-flex justify-content-center mb-1">
                    <b-spinner variant="success" label="Spinning" block v-if="loading"
                        style="width: 3rem; height: 3rem"></b-spinner>
                </div>
            </b-col>

            <b-col cols="12">
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
                    class="my-0" />
                <b-form-group>
                    Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import {
    BTable,
    BCard,
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormInput,
    BFormTextarea,
    BFormDatepicker,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner, 
    BPagination,
    BLink,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";

export default {
    components: {
        BTable,
        BCard,
        BRow,
        BCol,
        BForm,
        BFormGroup,
        BFormSelect,
        BFormInput,
        BFormTextarea,
        BFormDatepicker,
        BButton,
        BDropdown,
        BDropdownItem,
        BSpinner, 
        BPagination,
        BLink,
    },
    data() {
        return {
            id: this.$route.params.id,
            fields: [
                { key: "productName", label: "Product Name", sortable: true },
                { key: "stockLevel", label: "Stock Level", sortable: true },
            ],
            perPage: 5,
            pageOptions: [3, 5, 10],
            totalRows: 0,
            currentPage: 1,
            sortBy: "",
            sortDesc: false,
            sortDirection: "asc",
            filter: null,
            filterOn: [],
            itemBalance: [],
        }
    },
    async mounted() {
        await this.getWarehouseAction(this.id);
        this.itemBalance = this.warehouseId.itemBalance;
        this.totalRows = this.itemBalance.length;
    },
    methods: {
        ...mapActions("warehouseModule", ["getWarehouseAction"]),
        onFiltered: () => { },
        filtered: () => { },
        redirectProduct(id){
            this.$route.push({path:`/product/view/${id}`})
        }
    },
    computed: {
        ...mapGetters("warehouseModule", {
            warehouseId: "warehouseId",
            loading: "loading",
        }),
    },
}

</script>